import { useState } from "react";
import { TRADING_PAIRS, ALL_PAIRS } from "@/constants/pairs";
import { TID } from "@/constants/testIds";

export function PairPicker({ value, onChange }) {
  const [query, setQuery] = useState("");
  const q = query.trim().toUpperCase();
  return (
    <div>
      <input
        data-testid={TID.todayPairInput}
        value={query || value}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search or type a pair (e.g. XAU/USD)"
        className="w-full bg-[#0F0E0C] border border-[#2E2A25] text-[#EBE5D9] placeholder:text-[#A39A8E]/60 px-4 py-3 focus:outline-none focus:border-[#CFA66A] transition-colors rounded-sm font-mono"
      />
      <div className="mt-4 max-h-72 overflow-y-auto pr-2 space-y-4">
        {Object.entries(TRADING_PAIRS).map(([group, pairs]) => {
          const filtered = q
            ? pairs.filter((p) => p.replace("/", "").includes(q.replace("/", "")))
            : pairs;
          if (filtered.length === 0) return null;
          return (
            <div key={group}>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#A39A8E] mb-2">
                {group}
              </p>
              <div className="flex flex-wrap gap-2">
                {filtered.map((p) => {
                  const active = value === p;
                  return (
                    <button
                      key={p}
                      data-testid={TID.todayPairOption(p)}
                      onClick={() => {
                        onChange(p);
                        setQuery("");
                      }}
                      className={`px-3 py-1.5 border font-mono text-sm rounded-sm transition-colors ${
                        active
                          ? "bg-[#CFA66A] text-[#0F0E0C] border-[#CFA66A]"
                          : "bg-[#0F0E0C] border-[#2E2A25] text-[#EBE5D9] hover:border-[#CFA66A]"
                      }`}
                    >
                      {p}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
        {q && !ALL_PAIRS.some((p) => p.replace("/", "").includes(q.replace("/", ""))) && (
          <button
            onClick={() => {
              onChange(q);
              setQuery("");
            }}
            className="px-3 py-1.5 border font-mono text-sm rounded-sm bg-[#0F0E0C] border-[#CFA66A] text-[#CFA66A] hover:bg-[#CFA66A] hover:text-[#0F0E0C]"
          >
            Use custom: {q}
          </button>
        )}
      </div>
    </div>
  );
}
